module.exports = __webpack_public_path__ + "static/FontAwesome5_Regular-2e562d4ebf15395f00bc738738f79291.ttf";